import React, { Fragment } from 'react'

import { CLIENT_MODE } from "../../display_wallet.js"
import ClickToOpenCardDark from '../../components/ClickToOpenCardDark.js'
import { Row } from "../../components/Row"
import SwitchSlider from '../../components/SwitchSlider.js'


/**
 * Firewall section (admin only, not CLIENT_MODE) — toggle the Run trust
 * firewall on/off.
 *
 * Props:
 *   - run: the Run instance (or null while loading)
 *   - appLoadContext: AppLoadContext for triggering a wallet reload
 */
class SectionFirewall extends React.Component {

	constructor(props) {
		super(props)
		this.classname = "Slide_Settings/SectionFirewall: "

		this.state = {
			firewallActivated: true,
		}

		this.changeFireWall = this.changeFireWall.bind(this)
	}

	changeFireWall() {
		if (!this.props.run) {
			window.alert("wait for wallet to have fully loaded before doing this action")
			return
		}

		if (this.state.firewallActivated) {
			window.alert("Cliquez OK pour désactiver le pare-feu")
			this.props.run.trust("*")
		} else {
			window.alert("Cliquez OK pour activer le pare-feu")
			this.props.run.trust("state")
		}
		this.setState({ firewallActivated: !this.state.firewallActivated })

		this.props.appLoadContext.reload()
	}

	render() {
		if (CLIENT_MODE) return null

		const run = this.props.run
		const buttonsCustomStyle = {
			cursor: run ? "pointer" : "not-allowed",
			backgroundColor: run ? "" : "grey",
			pointerEvents: run ? "auto" : "none"
		}

		return (
			<Fragment>
				<ClickToOpenCardDark title="Firewall">
					<center><br />
						<div className="centered">
							Le parefeu protège votre application contre des envois de code malveillant sur votre adresse delphe.
							Il est hautement recommandé de le garder activé pendant que nous travaillons à renforcer la sécurité.
							<br /><br /><br />

							<Row style={{ display: "inline-block" }}>
								<SwitchSlider
									onChange={this.changeFireWall}
									checked={this.state.firewallActivated}
									style={buttonsCustomStyle}
								/>
								&nbsp;<i>Activate Firewall</i>
							</Row>
						</div>
					</center>
				</ClickToOpenCardDark>
				<br />
			</Fragment>
		)
	}
}

export default SectionFirewall
